import * as React from "react"
import cookie from "react-cookies"

import { Navigate, Outlet } from "react-router-dom"

export const PrivateRoute = () => {
 const token = cookie.load("token")

 return token ? <Outlet /> : <Navigate to="/login" />
}
